import TagManager, { TagManagerArgs } from "react-gtm-module";

if (process.env.REACT_APP_APP_STAGE === "production" && process.env.REACT_APP_GTM_ID) {
  const tagManagerArgs: TagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID ?? "",
  };

  TagManager.initialize(tagManagerArgs);
}
